import { GridCellProps } from '@progress/kendo-react-grid';
import { MouseEvent, useCallback } from 'react';
import GridCellBase, { useGridCellDisplayValue } from 'src/components/GridCellBase';
import useRedirect from 'src/hooks/useRedirect';
import { stopPropagation } from 'src/utils';

const ShoppingListCatalogCell = (props: GridCellProps) => {
  const { value } = useGridCellDisplayValue(props);
  const { getUrl, redirect } = useRedirect();
  const catalogId = props.dataItem?.catalogId as number | undefined;
  const categoryId = props.dataItem?.categoryId as number | undefined;
  const offlineSupplierId = props.dataItem?.offlineSupplierId as number | null | undefined;

  const handleOpenCatalog = useCallback(
    (event: MouseEvent<HTMLButtonElement>) => {
      stopPropagation(event);

      if (catalogId == null) {
        return;
      }

      const hasOfflineSupplier = (offlineSupplierId ?? 0) > 0;

      redirect(
        getUrl('viewProductList')(
          catalogId.toString(),
          hasOfflineSupplier ? null : categoryId ?? null,
          hasOfflineSupplier ? offlineSupplierId : null
        ),
        false,
        true
      );
    },
    [catalogId, getUrl, redirect, categoryId, offlineSupplierId]
  );

  if (!value || catalogId == null) {
    return (
      <GridCellBase {...props} rowSelectionEnabled={false} title={value}>
        {value}
      </GridCellBase>
    );
  }

  return (
    <GridCellBase {...props} rowSelectionEnabled={false} className="!p-0" title={value}>
      <button
        type="button"
        className="text-[#0E80B4] hover:underline focus:outline-2 focus:outline-black rounded text-left truncate w-[100%]"
        onClick={handleOpenCatalog}
      >
        {value}
      </button>
    </GridCellBase>
  );
};

export default ShoppingListCatalogCell;
